import { ReactComponent as Alert } from "assets/Alert.svg";
import { ReactComponent as ThumsUp } from "assets/thumsUp.svg";
import MetricsContent from "components/features/dashboard/MetricsContent";
import { tokens } from "styles/Tokens";
import { getThresholdDetails } from "utils/CommonFunctions";

export default function MetricDetails(props: any) {
  const { metric, metricsBar = true, sx = {} } = props;
  const metricValues = ["N/A", "NA", "-"];
  const { metricsValue: metricsValue1, metricName, timeFrameName, dateAsOf } = metric[0];
  const metricValue2 =
    !metricValues?.includes(metric[1]?.metricsValue) && metric[1]?.displayOnDashBoard === "Yes"
      ? metric[1]?.metricsValue
      : null;

  const getNumValue = (val1: any) => {
    const percentageValue: number = parseFloat(val1);
    return percentageValue;
  };

  const getColor = (cond1: any, cond2: any, label: string) => {
    if (cond1) {
      return {
        color: tokens.Text.Feedback.Done,
        label: label,
        icon: <ThumsUp />
      };
    } else if (cond2) {
      return {
        color: tokens.Text.Feedback.Alert,
        label: label,
        icon: <Alert />
      };
    } else {
      return {
        color: metricsBar ? tokens.Text.General.PrimaryHeadline : null,
        label: label
      };
    }
  };

  const getMetricsValues = () => {
    let metricData: any = {
      metricsName: metricName,
      dateAsOf: dateAsOf,
      timeFrameName: timeFrameName
    };
    if (metric[1]?.metricForImprovement === "Text") {
      const positiveIndicator = metric[1]?.metricsValue?.includes("Positive");
      const NegativeIndicator = metric[1]?.metricsValue?.includes("Negative");
      if (positiveIndicator || NegativeIndicator) {
        return {
          ...metricData,
          metricScoreDetails: getColor(positiveIndicator, NegativeIndicator, metricsValue1),
          metricValue2: metricValue2
        };
      } else
        return {
          ...metricData,
          metricScore: metricsValue1,
          chipDetails: metricValue2 && getThresholdDetails(metric[1]?.metricsValue)
        };
    } else {
      metricData = { ...metricData, metricValue2 };
      const val1 = getNumValue(metricsValue1);
      const val2 = getNumValue(metricValue2);
      switch (metric[1]?.metricForImprovement) {
        case ">": {
          return {
            ...metricData,
            metricScoreDetails: getColor(val1 >= val2, val1 < val2, metricsValue1)
          };
        }
        case "<": {
          return {
            ...metricData,
            metricScoreDetails: getColor(val1 <= val2, val1 > val2, metricsValue1)
          };
        }
        case "+": {
          return {
            ...metricData,
            metricScoreDetails: getColor(val1 >= 0, val1 < 0, metricsValue1)
          };
        }
        case "-": {
          return { ...metricData, metricScoreDetails: getColor(val1 <= 0, val1 > 0, metricsValue1) };
        }
        default: {
          return {
            ...metricData,
            metricScoreDetails: getColor(false, false, metricsValue1)
          };
        }
      }
    }
  };
  return (
    <>
      {metric?.length > 1 ? (
        <MetricsContent metricDetails={getMetricsValues()} metricsBar={metricsBar} sx={sx} />
      ) : (
        <MetricsContent
          metricsBar={metricsBar}
          sx={sx}
          metricDetails={{
            metricsName: metricName,
            metricScore: metricsValue1,
            timeFrameName: timeFrameName,
            dateAsOf: dateAsOf
          }}
        />
      )}
    </>
  );
}
